import { createStyles, rem } from '@mantine/core'

export default createStyles((theme, { isVn }: { isVn: boolean }) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: isVn ? 18 : 16,
      '.share-icon': {
        'svg, img': {
          borderRadius: 4,
          flex: 'auto',
        },
      },
    },
    heading: {},
    copyRoot: {
      position: 'relative',
      '&:has(input:disabled) .mantine-Input-rightSection': {
        display: 'block',
      },
    },
    copyHeading: {
      display: 'none',
    },
    copyInput: {
      '&:not(.mantine-Textarea-input)': {
        display: 'none',
      },
    },
    copyInputRightSection: {
      position: 'static',
      width: rem(32),
    },
    copyInputWrapper: {},
    copyBtn: {
      backgroundColor: theme.colors.gray[1],
    },
  }
})
